var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-card-title",
        [
          _c("EditableField", {
            attrs: {
              value: _vm.accountData.name,
              label: "Account Name",
              editing: _vm.editMode,
              "key-path": "name",
              "hide-label": true,
            },
            on: { save: _vm.handleFieldSave },
            scopedSlots: _vm._u([
              {
                key: "value",
                fn: function () {
                  return [_c("h1", [_vm._v(_vm._s(_vm.accountData.name))])]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "v-btn",
        {
          staticClass: "float-sm-right mt-2 mx-2",
          on: { click: _vm.toggleEdit },
        },
        [
          _c("v-icon", [
            _vm._v(
              _vm._s(_vm.editMode ? "mdi-content-save" : "mdi-account-edit")
            ),
          ]),
          _vm._v(" " + _vm._s(_vm.editMode ? "Save" : "Edit") + " "),
        ],
        1
      ),
      _vm.editMode
        ? _c(
            "v-btn",
            {
              staticClass: "btn-sm float-sm-right mt-2 mx-2",
              attrs: { text: "" },
              on: { click: _vm.cancelEdit },
            },
            [_vm._v(" Cancel ")]
          )
        : _vm._e(),
      _c("h2", [_vm._v("Account Details")]),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4", "cols-sm": "12" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("EditableField", {
                                attrs: {
                                  value: _vm.accountData.email,
                                  label: "Email",
                                  editing: _vm.editMode,
                                  "key-path": "email",
                                },
                                on: { save: _vm.handleFieldSave },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4", "cols-sm": "12" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [_vm._v("Created")]),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(_vm.account.created_at))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4", "cols-sm": "12" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [_vm._v("Last updated")]),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(_vm.account.updated_at))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }